/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_Paypal_TitleInputs */

const en_admin_settings_groups_paypal_title = /** @type {(inputs: Admin_Settings_Groups_Paypal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PayPal`)
};

/**
* | output |
* | --- |
* | "PayPal" |
*
* @param {Admin_Settings_Groups_Paypal_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_paypal_title = /** @type {((inputs?: Admin_Settings_Groups_Paypal_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_Paypal_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_groups_paypal_title(inputs)
});
export { admin_settings_groups_paypal_title as "admin.settings.groups.paypal.title" }